<template>
  <v-container>
    <v-row align="center" justify="center" class="pt-10">
      <v-card flat tile color="white">
        <v-card-text>
          <v-row justify="center">
            <span class="text-h3 primary--text">Thank you for reaching out to us.</span>
          </v-row>
          <v-row justify="center">
            <span class="headline">Our customer service will be in touch with you soon.</span>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style  scoped>
</style>